import styled from 'styled-components';

const CheckBoxLabel = styled.label`
  /* border: 5px solid orange; */
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  color: var(--grey700);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 4px;
  background: var(--${(props) => props.backgroundVariant || 'grey100'});
  cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
  input {
    outline: none;
    border: none;
    border-image: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input:checked {
    background-color: var(--accent-color-blue);
    border: 1px solid var(--accent-color-blue);
  }
`;

export default CheckBoxLabel;
